import { render } from "./DataInteraction.vue?vue&type=template&id=3f569932&scoped=true"
import script from "./DataInteraction.vue?vue&type=script&lang=js"
export * from "./DataInteraction.vue?vue&type=script&lang=js"

import "./DataInteraction.vue?vue&type=style&index=0&id=3f569932&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f569932"]])

export default __exports__